export default __webpack_public_path__ + "static/media/faq2.ec2a04be.png";